// «Приложение на телефоне» в настройках (PWA, DESIGN §7): платформа ставится на главный экран и открывается
// без адресной строки, как приложение. Android и компьютер — своя кнопка установки браузера; iPhone —
// через «Поделиться → На экран «Домой»» (Safari не даёт сайтам кнопку установки).
import { Button, Card, Chip, toast } from '@autoaff/ui';
import { Download, Share, SquarePlus } from 'lucide-react';
import { isIos, promptInstall, usePwa } from '../pwa';

export function InstallCard() {
  const pwa = usePwa();
  const install = async () => {
    const ok = await promptInstall();
    toast(ok ? 'Приложение установлено — оно на главном экране' : 'Установку можно сделать позже');
  };
  return (
    <Card
      title="Приложение на телефоне"
      action={pwa.installed ? <Chip tone="success">Установлено</Chip> : undefined}
    >
      {pwa.installed ? (
        <p className="muted inst-text">
          Платформа открыта как приложение: без адресной строки, со своим значком и уведомлениями.
        </p>
      ) : pwa.installEvent ? (
        <div className="inst-row">
          <p className="muted inst-text">
            Поставьте платформу на главный экран: открывается одним нажатием, как приложение, и присылает
            уведомления.
          </p>
          <Button variant="primary" onClick={install}>
            <Download />
            Установить
          </Button>
        </div>
      ) : isIos() ? (
        <ol className="inst-steps">
          <li>
            Откройте платформу в Safari и нажмите <Share aria-label="Поделиться" className="inst-ico" />{' '}
            «Поделиться».
          </li>
          <li>
            Выберите <SquarePlus aria-hidden className="inst-ico" /> «На экран «Домой»» и нажмите «Добавить».
          </li>
          <li>Откройте AutoAFF с главного экрана — уведомления на iPhone работают только так.</li>
        </ol>
      ) : (
        <p className="muted inst-text">
          Откройте платформу на телефоне в Chrome (Android) или Safari (iPhone) — здесь появится кнопка или
          подсказка, как поставить её на главный экран.
        </p>
      )}
    </Card>
  );
}
